import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectHasRamp = createSelector(selectJsonQuery, jsonQuery => getTermValue('has_ramp')(jsonQuery));
